var _mask, _path, _path2, _mask2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1639,
    height: 144,
    viewBox: "0 0 1639 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_202_2823",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1639,
    height: 144
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_202_2823",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H1629C1634.52 0 1639 4.47715 1639 10V134C1639 139.523 1634.52 144 1629 144H9.99995C4.4771 144 0 139.523 0 134V10Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H1629C1634.52 0 1639 4.47715 1639 10V134C1639 139.523 1634.52 144 1629 144H9.99995C4.4771 144 0 139.523 0 134V10Z",
    fill: "#276665"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-4 10C-4 2.26801 2.26801 -4 10 -4H1635C1642.73 -4 1649 2.26801 1649 10H1629C1629 6.68629 1629 4 1629 4H10C6.68629 4 4 6.68629 4 10H-4ZM1649 134C1649 145.046 1640.05 154 1629 154H10C2.26801 154 -4 147.732 -4 140L4 134C4 134 6.68629 134 10 134H1629H1649ZM10 154C2.26801 154 -4 147.732 -4 140V10C-4 2.26801 2.26801 -4 10 -4V4C6.68629 4 4 6.68629 4 10V134C4 134 6.68629 134 10 134V154ZM1635 -4C1642.73 -4 1649 2.26801 1649 10V134C1649 145.046 1640.05 154 1629 154V134V10C1629 6.68629 1629 4 1629 4L1635 -4Z",
    fill: "black",
    mask: "url(#path-1-inside-1_202_2823)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_202_2823)"
  }, _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_202_2823",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H1629C1634.52 0 1639 4.47715 1639 10V134C1639 139.523 1634.52 144 1629 144H9.99995C4.4771 144 0 139.523 0 134V10Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H1629C1634.52 0 1639 4.47715 1639 10V134C1639 139.523 1634.52 144 1629 144H9.99995C4.4771 144 0 139.523 0 134V10Z",
    fill: "#276665"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-4 10C-4 2.26801 2.26801 -4 10 -4H1635C1642.73 -4 1649 2.26801 1649 10H1629C1629 6.68629 1629 4 1629 4H10C6.68629 4 4 6.68629 4 10H-4ZM1649 134C1649 145.046 1640.05 154 1629 154H10C2.26801 154 -4 147.732 -4 140L4 134C4 134 6.68629 134 10 134H1629H1649ZM10 154C2.26801 154 -4 147.732 -4 140V10C-4 2.26801 2.26801 -4 10 -4V4C6.68629 4 4 6.68629 4 10V134C4 134 6.68629 134 10 134V154ZM1635 -4C1642.73 -4 1649 2.26801 1649 10V134C1649 145.046 1640.05 154 1629 154V134V10C1629 6.68629 1629 4 1629 4L1635 -4Z",
    fill: "black",
    mask: "url(#path-3-inside-2_202_2823)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.17 0C44.8961 18.6114 47.0099 41.8144 63.9534 58.8961L96.1191 91.3241C106.071 101.357 119.617 107 133.748 107H1639V134C1639 139.523 1634.52 144 1629 144H9.99995C4.4771 144 0 139.523 0 134V10C0 4.47715 4.47715 0 10 0H53.17Z",
    fill: "black",
    fillOpacity: 0.22
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeader);
export default __webpack_public_path__ + "static/media/header.3ea5b046344f45de5d04c24cc4a0bb78.svg";
export { ForwardRef as ReactComponent };